export default __webpack_public_path__ + "static/media/chargeBusinessInfo.d82a10c7.png";